import { Link } from "react-router-dom";

const ScreenHeader = (props) => {
  const { screenHeaderTitle = "", to = "/", hidden = false } = props;
  return (
    <div className="mb-sm-3 gap-2 d-sm-flex flex-sm-row gap-2 align-items-flex-start align-items-sm-center justify-content-between">
      <Link hidden={hidden} to={to} className="btn btn-primary" style={{ maxHeight: "38px" }}>
        <span>Volver</span>
      </Link>

      <h3 className="my-2 my-sm-0 text-wrap">{screenHeaderTitle}</h3>
      {/* <hr /> */}
      <div className="d-none d-sm-block " style={{ width: "54px" }}></div>
    </div>
  );
};

export default ScreenHeader;
